import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useOnboarding } from "@/hooks/use-onboarding";

export function CompleteStep() {
  const navigate = useNavigate();
  const { completeStep } = useOnboarding();
  const hasMarkedComplete = useRef(false);

  useEffect(() => {
    if (hasMarkedComplete.current) return;
    hasMarkedComplete.current = true;

    completeStep("has_completed_onboarding").catch(() => {
      // Silently handle - user can still proceed
    });
  }, [completeStep]);

  const handleGoToDashboard = () => {
    navigate("/dashboard", { replace: true });
  };

  return (
    <div className="flex flex-col items-center text-center space-y-6 py-12">
      <div className="h-20 w-20 rounded-full bg-green-100 dark:bg-green-900/30 flex items-center justify-center animate-in zoom-in duration-500">
        <CheckCircle className="h-12 w-12 text-green-600 dark:text-green-400" />
      </div>

      <div className="space-y-3">
        <h2 className="text-3xl font-bold tracking-tight">Tudo pronto!</h2>
        <p className="text-muted-foreground max-w-md">
          Sua conta está configurada. Agora você pode começar a organizar
          suas finanças e acompanhar seus gastos.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 w-full max-w-sm pt-4">
        <div className="flex items-center gap-2 p-3 rounded-lg bg-muted/50 text-sm">
          <CheckCircle className="h-4 w-4 text-green-600 shrink-0" />
          <span>Plano selecionado</span>
        </div>
        <div className="flex items-center gap-2 p-3 rounded-lg bg-muted/50 text-sm">
          <CheckCircle className="h-4 w-4 text-green-600 shrink-0" />
          <span>Termos aceitos</span>
        </div>
        <div className="flex items-center gap-2 p-3 rounded-lg bg-muted/50 text-sm">
          <CheckCircle className="h-4 w-4 text-green-600 shrink-0" />
          <span>Conta criada</span>
        </div>
        <div className="flex items-center gap-2 p-3 rounded-lg bg-muted/50 text-sm">
          <CheckCircle className="h-4 w-4 text-green-600 shrink-0" />
          <span>Tudo configurado</span>
        </div>
      </div>

      <Button onClick={handleGoToDashboard} size="lg" className="mt-6">
        Ir para o Dashboard
      </Button>
    </div>
  );
}
